import React from 'react';
import classNames from 'classnames';
import { get } from '@libs/shared';
import { Intl } from '../../constants';

interface IFieldTypeItem {
    className?: string;
    type: string;
    styleMap?: Record<string, any>;
}

const defaultStyleMap: any = () => {
    return {
        string: { cls: 'color-string', text: Intl.get('text') },
        number: { cls: 'color-number', text: Intl.get('widget.number') },
        datetime: { cls: 'color-datetime', text: Intl.get('timestamp') },
        array: { cls: 'color-array', text: Intl.get('array') },
        address: { cls: 'color-address', text: Intl.get('widget.address') },
        location: { cls: 'color-location', text: Intl.get('widget.location') },
        phone: { cls: 'color-phone', text: Intl.get('phone') },
        id: { cls: 'color-user', text: Intl.get('member') },
        idarray: { cls: 'color-usergroup', text: Intl.get('widget.usergroup') },
        did: { cls: 'color-dept', text: Intl.get('department') },
        didarray: { cls: 'color-deptgroup', text: Intl.get('widget.deptgroup') },
        url: { cls: 'color-url', text: Intl.get('widget.url') },
        aggregation: { cls: 'color-number', text: Intl.get('widget.number') }
    };
};

const FieldTypeItem: React.FC<IFieldTypeItem> = (props) => {
    const { className, type, styleMap = defaultStyleMap() } = props;

    const comboItem = get(styleMap, [type]);
    return (
        <div className={classNames('field-type', className, get(comboItem, 'cls'))}>
            {comboItem?.text}
        </div>
    );
};

export default FieldTypeItem;
